/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountCustomerClubDetailDto } from '../models/AccountCustomerClubDetailDto';
import type { AccountDetailDto } from '../models/AccountDetailDto';
import type { AccountGiftDtoListResult } from '../models/AccountGiftDtoListResult';
import type { AccountInvoiceInformationDto } from '../models/AccountInvoiceInformationDto';
import type { AccountInvoiceInformationInput } from '../models/AccountInvoiceInformationInput';
import type { AccountScoreLevelDefinition } from '../models/AccountScoreLevelDefinition';
import type { AccountSettingsDto } from '../models/AccountSettingsDto';
import type { CategorizationInput } from '../models/CategorizationInput';
import type { SendOtpInput } from '../models/SendOtpInput';
import type { SetAccountSettingInput } from '../models/SetAccountSettingInput';
import type { SignupBonusDto } from '../models/SignupBonusDto';
import type { SupportContactInfoDto } from '../models/SupportContactInfoDto';
import type { VerifyCodeInput } from '../models/VerifyCodeInput';
import type { VerifyOtpAndResetAccountInput } from '../models/VerifyOtpAndResetAccountInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AccountService {

    /**
     * @param version 
     * @returns AccountDetailDto OK
     * @throws ApiError
     */
    public static getAccountDetail(
version: string,
): CancelablePromise<AccountDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Account/Detail',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns AccountSettingsDto OK
     * @throws ApiError
     */
    public static getAccountSettings(
version: string,
): CancelablePromise<AccountSettingsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Account/Settings',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static setAccountSettings(
version: string,
requestBody?: SetAccountSettingInput,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Account/Settings',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static resetAccount(
version: string,
requestBody?: VerifyOtpAndResetAccountInput,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Account/Reset',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static freezeAccount(
version: string,
requestBody?: VerifyCodeInput,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Account/Freeze',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static unFreezeAccount(
version: string,
requestBody?: VerifyCodeInput,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Account/UnFreeze',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static sendOtp(
version: string,
requestBody?: SendOtpInput,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Account/Otp',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param limit 
     * @param offset 
     * @returns AccountGiftDtoListResult OK
     * @throws ApiError
     */
    public static listGifts(
version: string,
limit?: number,
offset?: number,
): CancelablePromise<AccountGiftDtoListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Account/Gifts',
            path: {
                'version': version,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * @param version 
     * @returns AccountCustomerClubDetailDto OK
     * @throws ApiError
     */
    public static getCustomerLoyaltyDetail(
version: string,
): CancelablePromise<AccountCustomerClubDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Account/Loyalty',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns AccountScoreLevelDefinition OK
     * @throws ApiError
     */
    public static getLoyaltyLevels(
version: string,
): CancelablePromise<Array<AccountScoreLevelDefinition>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Account/Loyalty/Levels',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns SignupBonusDto OK
     * @throws ApiError
     */
    public static getSignupBonus(
version: string,
): CancelablePromise<SignupBonusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Account/Signup/Bonus',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns boolean OK
     * @throws ApiError
     */
    public static isCategorizationRequired(
version: string,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Account/Categorization/Requirement',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static setCategorization(
version: string,
requestBody?: CategorizationInput,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Account/Categorization',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @returns SupportContactInfoDto OK
     * @throws ApiError
     */
    public static getSupportContactInformation(
version: string,
): CancelablePromise<SupportContactInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Account/Support/ContactInformation',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns AccountInvoiceInformationDto OK
     * @throws ApiError
     */
    public static getInvoiceInformation(
version: string,
): CancelablePromise<AccountInvoiceInformationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Account/Invoice/Information',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static setInvoiceInformation(
version: string,
requestBody?: AccountInvoiceInformationInput,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Account/Invoice/Information',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
